import { QuestionCircleOutlined } from '@ant-design/icons'
import { Auth } from '@common/Auth'
import { WEI_SHOP_PATH_A } from '@constant'
import { ctrlTextLen } from '@hlj/hlj-utils'
import {
  isHonorable,
  isHotelProperty,
  isPureUltimate,
  isSiDaProperty,
  isStandard
} from '@merchant-backend/util'
import {
  getMerchantInfo,
  getProTitle,
  isNormalRole,
  isSiDaMember,
  isTelSaleCityMerchant
} from '@util'
import { Flex, Tooltip } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import auth, { STORE_INFO } from '../auth'
import store from '../store'
import GroupVTag from './GroupVTag'
import HiddenShop from './HiddenShop'
import LiteApp from './LiteApp'
import SiDaHot from './SiDaHot'
import style from './style.module.less'

/** 店铺信息 */
@auth(STORE_INFO)
@observer
export default class extends Component {
  getProTypeImage = () => {
    if (isHonorable()) {
      return style.zunXiangImg
    }

    if (isPureUltimate()) {
      return style.proImg
    }

    if (isStandard()) {
      return style.standardImg
    }

    if (isTelSaleCityMerchant()) {
      return style.notZunXiangImg
    }

    return style.notProImg
  }
  render() {
    if (getMerchantInfo().hidden) {
      // 店铺被隐藏
      return <HiddenShop />
    }

    let { logo_path = '', name, is_special, id, v_tag } = getMerchantInfo()
    const { is_overflow } = store

    const logo =
      logo_path && logo_path.indexOf('imageMogr2') > -1
        ? logo_path
        : logo_path + '?imageView2/1/w/640/h/640'

    return (
      <div className={style.merchant}>
        <div className={style.rightLogoMask} />
        <div
          className={style.rightLogo}
          style={{ backgroundImage: `url(${logo})` }}
        />
        <div className={style.info} id="info">
          <img src={logo} className={style.logo} />
          <div>
            <div className={style.name}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative'
                }}
              >
                <span style={{ marginRight: 15 }}>
                  {is_overflow ? ctrlTextLen(name, 10, '...') : name}
                </span>

                <GroupVTag data={v_tag} />
                {isSiDaMember() && <SiDaHot />}

                {is_special == 1 && (
                  <div className={style.flag}>
                    主店铺
                    <Tooltip
                      getPopupContainer={() => document.body}
                      placement="topLeft"
                      title={`对主店铺套餐、案例、动态的操作将同步至其余所有${getProTitle()}子店铺中`}
                      arrowPointAtCenter
                    >
                      <QuestionCircleOutlined
                        style={{ cursor: 'pointer', marginLeft: -4 }}
                      />
                    </Tooltip>
                  </div>
                )}
              </div>
            </div>
            <Flex vc>
              <Auth
                condition={
                  isNormalRole() && !isHotelProperty() && !isSiDaProperty()
                }
              >
                <LiteApp
                  style={{
                    // marginLeft: 40,
                    fontSize: 12,
                    color: '#508cee'
                  }}
                />
              </Auth>

              <Auth condition={!isSiDaProperty()}>
                <a
                  href={WEI_SHOP_PATH_A}
                  style={{
                    marginLeft: 20,
                    fontSize: 12,
                    verticalAlign: 'middle'
                  }}
                >
                  店铺微官网
                </a>
              </Auth>

              <Auth condition={!isSiDaProperty()}>
                <a
                  href={
                    isHotelProperty()
                      ? `/w/Detail/detail/type/merchant/id/${id}/admin/true`
                      : `https://www.hunliji.com/merchant/detail_${id}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    marginLeft: 20,
                    fontSize: 12,
                    verticalAlign: 'middle'
                  }}
                >
                  店铺官网
                </a>
              </Auth>
            </Flex>
          </div>
        </div>
      </div>
    )
  }
}
